// 🐋 Whale Magnet — free DexScreener-only signal for "whale-sized money is flowing in".
// avg trade size (h1) well above typical retail + healthy buy pressure = big money entering.
export const WHALE_MIN_AVG_USD = 200;
export const WHALE_MIN_TXNS = 12;

export const whaleAvgBuy = (c) => {
  const t = c?.txns?.h1 || {};
  const n = (t.buys || 0) + (t.sells || 0);
  const vol = c?.volume?.h1 || 0;
  if (!n || !vol) return 0;
  return Math.round(vol / n);
};

export const isWhaleMagnet = (c) => {
  const t = c?.txns?.h1 || {};
  const buys = t.buys || 0;
  const sells = t.sells || 0;
  if (buys + sells < WHALE_MIN_TXNS) return false;
  return whaleAvgBuy(c) >= WHALE_MIN_AVG_USD && buys >= sells;
};
